module.exports = __webpack_public_path__ + "c2dec215572cb222204f7a3a5f883433.png";